import { PropsWithChildren, ReactNode } from 'react';

export const createSlotComponent = (slotName: string) => {
    const SlotComponent = (props: PropsWithChildren) => props?.children;
    SlotComponent.slotName = slotName;
    return SlotComponent;
};

export const getChildSlot = (children: ReactNode[], slotName: string) =>
    children.find((child) => (child as any)?.type?.slotName === slotName);
